import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { getOnboardingKey, readJson } from './useOnboardingDraft';

/**
 * `/sign-up` with a session (e.g. browser back from `/onboarding/que-vendes` lands on the
 * `?step=cuenta` entry). Resumes an unfinished signup v2 onboarding; otherwise goes home, like
 * App's existing `redirectToHomeRoutes`.
 */
const SignUpAuthedRedirect = () => {
    const storeId = useSelector((state) => state.auth.storeId);
    const onboarding = storeId ? readJson('local', getOnboardingKey(storeId)) : {};
    const unfinished = Object.keys(onboarding).length > 0 && !onboarding.completedAt;

    return <Redirect to={unfinished ? '/onboarding' : '/'} />;
};

export default SignUpAuthedRedirect;
